module.exports = __webpack_public_path__ + "img/btn-off.892607fe.png";